// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wrapper for the form */
.form-wrapper {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  color: #ffffff;
  position: relative;
}

/* Form header */
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  color: #000000ad;
}
.form-header + p{
  color: #000000ad;
}

.form-title {
  color: #000000ad;
  margin: 0;
}

.form-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
}

.form-close-btn:hover {
  color: #009afc;
}

/* Form input styling */
.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  font-weight: 500;
  color: #000000ad;
  margin-bottom: 10px;
}

.form-control {
  background-color: transparent;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  color: #1B1F2E;
}

.form-control:focus {
  border-color: #009afc;
  box-shadow: 0 0 5px rgba(0, 154, 252, 0.5);
}

/* Submit button styling */
.btn {
  margin-top: 10px;
  background-color: #009afc;
  border: none;
  color: #ffffff;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #009bfcdb;
}

/* Quill Editor Styling */
.ql-container {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #1B1F2E;
  padding: 5px;
  min-height: 200px; /* Adjust the minimum height */
}

.ql-editor {
  min-height: 150px; /* Minimum height for the editor */
  color: #1B1F2E;
  padding: 10px;
}

.ql-toolbar {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #1B1F2E;
}

.ql-container.ql-snow {
  border-radius: 4px;
}

.ql-toolbar button:hover {
  background-color: #009afc;
}

/* Error message styling */
.error-text {
  color: red;
  font-size: 0.9rem;
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/styles/Form.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,iBAAiB,EAAE,8BAA8B;AACnD;;AAEA;EACE,iBAAiB,EAAE,kCAAkC;EACrD,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":["/* Wrapper for the form */\n.form-wrapper {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #fff;\n  color: #ffffff;\n  position: relative;\n}\n\n/* Form header */\n.form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  color: #000000ad;\n}\n.form-header + p{\n  color: #000000ad;\n}\n\n.form-title {\n  color: #000000ad;\n  margin: 0;\n}\n\n.form-close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.form-close-btn:hover {\n  color: #009afc;\n}\n\n/* Form input styling */\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  font-weight: 500;\n  color: #000000ad;\n  margin-bottom: 10px;\n}\n\n.form-control {\n  background-color: transparent;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 10px;\n  color: #1B1F2E;\n}\n\n.form-control:focus {\n  border-color: #009afc;\n  box-shadow: 0 0 5px rgba(0, 154, 252, 0.5);\n}\n\n/* Submit button styling */\n.btn {\n  margin-top: 10px;\n  background-color: #009afc;\n  border: none;\n  color: #ffffff;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.btn:hover {\n  background-color: #009bfcdb;\n}\n\n/* Quill Editor Styling */\n.ql-container {\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  color: #1B1F2E;\n  padding: 5px;\n  min-height: 200px; /* Adjust the minimum height */\n}\n\n.ql-editor {\n  min-height: 150px; /* Minimum height for the editor */\n  color: #1B1F2E;\n  padding: 10px;\n}\n\n.ql-toolbar {\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  color: #1B1F2E;\n}\n\n.ql-container.ql-snow {\n  border-radius: 4px;\n}\n\n.ql-toolbar button:hover {\n  background-color: #009afc;\n}\n\n/* Error message styling */\n.error-text {\n  color: red;\n  font-size: 0.9rem;\n  margin-top: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
